import { templateSensor, reuseCheckbox } from '../../base/view/template';

export const sensorFields = `
<gz-form-field label="" id="o365_audit_applicationid" required stacked>
  <gz-input gz-form-input="" type="text" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>
<gz-form-field label="" id="o365_audit_tenantid" required stacked>
  <gz-input gz-form-input="" type="text" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>
<gz-form-field label="" id="o365_audit_client_secret" required stacked>
  <gz-input gz-form-input="" type="password" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>`;

export const templateO365Audit = document.createElement('template');

templateO365Audit.innerHTML = `${templateSensor
  .replace('{sensorFields}', sensorFields)
  .replace('{sensorDataReuse}', reuseCheckbox)}`;
